import { Paper, Stack } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { QUERY_KEYS } from '../../constants';
import { FEED_CONTROL_SETTINGS } from '../../constants/superAdminFlags';
import { useFeedTemplateSwitch } from '../../hooks/useFeedTemplateSwitch';
import { FeedTemplateSwitchView } from '../organisms/FeedTemplateSwitch';
import RequestFeedSnapshot from '../organisms/RequestFeedSnapshot';
import SuperAdminFlagControls from '../organisms/SuperAdminFlagControls';

const SuperAdminFeedControlPage = () => {
  const controls = useFeedTemplateSwitch();
  const queryClient = useQueryClient();
  const finishedAt = controls.operation?.finishedAt;

  useEffect(() => {
    void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.superAdminFlags] });
  }, [queryClient, controls.feedRunning, finishedAt]);

  return (
    <SuperAdminFlagControls
      title='Feed Control Panel'
      description='Feed operation, FTB processing, and provider status. Changes affect every marketplace in this environment.'
      settings={FEED_CONTROL_SETTINGS}
      disabledReason={
        controls.controlsBlocked
          ? 'Feed controls are read-only while a template switch is running or its start request is being confirmed.'
          : undefined
      }
    >
      <Paper elevation={0} sx={{ p: { xs: 2, md: 3 }, borderRadius: 2 }}>
        <Stack spacing={3}>
          <FeedTemplateSwitchView controls={controls} />
          <RequestFeedSnapshot disabled={controls.controlsBlocked} />
        </Stack>
      </Paper>
    </SuperAdminFlagControls>
  );
};

export default SuperAdminFeedControlPage;
